const SvgIcon = ({ size = '24', color = '#fff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="2"
    className="lucide lucide-link2-icon lucide-link-2"
    version="1.1"
    viewBox="0 0 24 24"
  >
    <path
      fill={color}
      stroke="none"
      d="M7 6c-1.917 0-3.481.755-4.498 1.898C1.485 9.042 1 10.528 1 12s.485 2.958 1.502 4.102C3.519 17.245 5.083 18 7 18h2a1 1 0 0 0 1-1 1 1 0 0 0-1-1H7c-1.417 0-2.352-.495-3.002-1.227C3.348 14.043 3 13.028 3 12s.348-2.042.998-2.773S5.583 8 7 8h2a1 1 0 0 0 1-1 1 1 0 0 0-1-1Z"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      d="M15 6a1 1 0 0 0-1 1 1 1 0 0 0 1 1h2c2.221 0 4 1.779 4 4s-1.779 4-4 4h-2a1 1 0 0 0-1 1 1 1 0 0 0 1 1h2c3.302 0 6-2.698 6-6s-2.698-6-6-6z"
      color="#000"
    ></path>
    <path
      fill={color}
      stroke="none"
      d="M8 11a1 1 0 0 0-1 1 1 1 0 0 0 1 1h8a1 1 0 0 0 1-1 1 1 0 0 0-1-1z"
      color="#000"
    ></path>
  </svg>
);

export default SvgIcon;

